import { render, staticRenderFns } from "./VineyardPowerMetricTable.vue?vue&type=template&id=07f13fba&scoped=true&"
import script from "./VineyardPowerMetricTable.vue?vue&type=script&lang=js&"
export * from "./VineyardPowerMetricTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f13fba",
  null
  
)

export default component.exports